import noImageUniversal from '../assets/no-image-new2.png';
export const NO_IMAGE_LINK =
  'https://cdn.parfumart.ru/internal-images/no-photo-parfume.svg';
export const NO_IMAGE_LINK_KOSMETIKA =
  'https://cdn.parfumart.ru/internal-images/no-photo-kosmetic.svg';
export const NO_IMAGE_LINK_UNIVERSAL = noImageUniversal;
